export default __webpack_public_path__ + "static/media/loader.8981e9a5.gif";